import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root',
})
export class AdminFeedbackService {
  constructor(@Inject(DialogService) private dialogService: DialogService) {}

  /**
   * Gemensam felhantering för CRUD i admin.
   *
   * Princip:
   * - väntade fel ska visas i appens modal, inte bara loggas
   * - backendens begripliga message ska återanvändas när det finns
   * - FK-/referensfel ska bli ett tydligt 409-flöde i UI
   */
  async showCrudError(action: 'skapa' | 'uppdatera' | 'ta bort' | 'hämta', entity: string, error: unknown): Promise<void> {
    console.error(`Admin ${action} ${entity} failed`, error);

    const bodyText = this.buildMessage(action, entity, error);

    await this.dialogService.alert({
      title: 'Operationen misslyckades',
      body: bodyText,
      buttonText: 'OK',
      variant: 'danger',
    });
  }

  private buildMessage(action: 'skapa' | 'uppdatera' | 'ta bort' | 'hämta', entity: string, error: unknown): string {
    const httpError = error as HttpErrorResponse | undefined;
    const backendMessage =
      typeof httpError?.error?.message === 'string'
        ? httpError.error.message
        : typeof httpError?.error?.error === 'string'
          ? httpError.error.error
          : null;

    if (httpError?.status === 409) {
      return (
        backendMessage ||
        `Det går inte att ${action} ${entity} eftersom posten används av andra poster i systemet.`
      );
    }

    if (httpError?.status === 0 || httpError?.status === 504) {
      return 'Backend-servern svarar inte. Kontrollera att servern körs och försök igen.';
    }

    if (backendMessage) {
      return backendMessage;
    }

    return `Det gick inte att ${action} ${entity}. Försök igen eller kontrollera serverloggen.`;
  }
}
